import { useEffect } from "react";
import { company } from "@/data/site";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight SEO manager — sets title, description, OG & Twitter tags,
 * canonical URL and JSON-LD structured data per page.
 */
export default function SEO({ title, description, path = "", image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${company.name}` : `${company.name} — ${company.tagline}`;
    const desc = description || company.description;
    const url = `${window.location.origin}${path}`;
    const img = image || `${window.location.origin}/logo.jpg`;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let ld = document.head.querySelector("#ntq-ldjson");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "ntq-ldjson";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: company.name,
      description: company.description,
      email: company.email,
      telephone: company.phone,
      url: window.location.origin,
      address: { "@type": "PostalAddress", streetAddress: company.address },
    });
  }, [title, description, path, image]);

  return null;
}
